import { useQuery } from "@tanstack/react-query";
import { additionalInfo } from "../templates/TroubleShooting/actions";

const params = {
  deviceSku: window?.troubleShootingJson?.ddata?.device?.deviceSku ?? "",
  combinedSelector: window?.config?.caseDetails?.combinedSelector ?? false,
};

const useAdditionalInfo = () =>
  useQuery({
    queryKey: ["additionalInfo"],
    queryFn: async () => {
      const { response, success } = await additionalInfo(params);
      const body = response?.data?.body || {};
      return {
        ...body,
        success,
      };
    },
  });

export default useAdditionalInfo;
